import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import root from "./assets/styles/Root.module.css";
import "./assets/styles/Fonts.module.css";

import LayoutSidebar from "./layouts/LayoutSidebar";
import LayoutNotFooter from "./layouts/LayoutNotFooter";
import LayoutFooterFixed from "./layouts/LayoutFooterFixed";
import LayoutClean from "./layouts/LayoutClean";

import ExplorePage from "./pages/ExplorePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import CasesPage from "./pages/CasesPage";
import TicketsPage from "./pages/TicketsPage";
import TicketChatPage from "./pages/TicketChatPage";

import ScrollToTop from "./components/ScrollToTop";
import RequireAuth from "./components/RequireAuth";
import { AuthProvider } from "./context/AuthContext";
import BattlesPage from "./pages/BattlesPage";
import BattleRoomPage from "./pages/BattleRoomPage";

function App() {
   return (
      <div className={root.app}>
         <AuthProvider>
            <Router>
               <ScrollToTop />
               <Routes>
                  {/* Новый лэйаут: сайдбар */}
                  <Route element={<LayoutSidebar />}>
                     <Route path="/" element={<CasesPage />} />
                     <Route path="/cases" element={<CasesPage />} />
              <Route path="/battles" element={<RequireAuth><BattlesPage /></RequireAuth>} />
              <Route path="/battles/:id" element={<RequireAuth><BattleRoomPage /></RequireAuth>} />
                     {/* Пример приватного роута (доступен только после логина) */}
                     <Route
                        path="/profile"
                        element={
                           <RequireAuth>
                              <ProfilePage />
                           </RequireAuth>
                        }
                     />
                     <Route
                        path="/tickets"
                        element={
                           <RequireAuth>
                              <TicketsPage />
                           </RequireAuth>
                        }
                     />
                     <Route
                        path="/tickets/:id"
                        element={
                           <RequireAuth>
                              <TicketChatPage />
                           </RequireAuth>
                        }
                     />
                  </Route>

                  {/* Лэйаут без футера (если понадобится для каких-то страниц) */}
                  <Route element={<LayoutNotFooter />}>
                     {/* примеры:
              <Route path="/edit-profile" element={<RequireAuth><EditProfilePage/></RequireAuth>} />
              */}
                  </Route>

                  {/* Лэйаут с «липким» футером (пример) */}
                  <Route element={<LayoutFooterFixed />}>
                     {/* примеры:
              <Route path="/account-deleted" element={<AccountDeletedPage />} />
              */}
                  </Route>

                  {/* Чистый лэйаут — используем для auth-страниц */}
                  <Route element={<LayoutClean />}>
                     <Route path="/login" element={<LoginPage />} />
                     <Route path="/register" element={<RegisterPage />} />
                  </Route>

                  {/* 404 по желанию */}
                  {/* <Route path="*" element={<LayoutClean><NotFoundPage /></LayoutClean>} /> */}
               </Routes>
            </Router>
         </AuthProvider>
      </div>
   );
}

export default App;
